import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UntilDestroy } from '@ngneat/until-destroy';
import { connectState } from '@y42/angular/util';
import { GitQuery, GitService } from '@y42/git';
import { merge, switchMap } from 'rxjs';
import { GitStashedChangesDialogComponent } from '../git-stashed-changes-dialog/git-stashed-changes-dialog.component';

@UntilDestroy()
@Component({
  selector: 'y42-git-stashed-changes-button',
  templateUrl: './git-stashed-changes-button.component.html',
  styleUrls: ['./git-stashed-changes-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GitStashedChangesButtonComponent {
  constructor(
    private readonly gitQuery: GitQuery,
    private readonly gitService: GitService,
    private readonly dialog: MatDialog,
  ) {}

  @Input() showRightChevron = true;
  @Input() btnClass = 'border';

  readonly state = connectState(this, {
    stashedChanges: merge(this.gitQuery.activeBranch$, this.gitQuery.wasInStatus('stash')).pipe(
      switchMap(() => this.gitService.getBranchStashedChanges()),
    ),
  });

  showStashedChanges() {
    this.dialog.open(GitStashedChangesDialogComponent, {
      width: '80vw',
      height: '80vh',
      panelClass: ['full-screen-popup'],
      autoFocus: false,
    });
  }
}
